import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

/**
 * Global connectivity banner (issue #6). When the browser goes offline, users
 * get an explicit in-app message rather than being confused by blank/stale
 * dashboards or the browser's native error page. Mounted once at app root.
 */
export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-sm font-medium text-amber-950 shadow-md"
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>You&rsquo;re offline. Some features may be unavailable until your connection returns.</span>
    </div>
  );
}
